import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { Modal } from "./boxModal";
import { ManualReceiptModal } from "./additionalInfoModal";

export function CameraModal({
  isOpen,
  onClose,
  onSubmitPhoto,
  capturedFile,
  setCapturedFile,
  setAdditionalInfo,
  missingFields,
  isManualModalOpen,
  setIsManualModalOpen
}) {
  const webcamRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false); 

  const videoConstraints = {
    facingMode: "environment",
    width: 1920,
    height: 1080,
    aspectRatio: 16 / 9,
  };

  const handleCapture = () => {
    if (!webcamRef.current) return;

    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return;

    setPreview(imageSrc);

    const file = dataURLtoFile(imageSrc, "document-photo.jpg");
    setCapturedFile(file);
  };

  const handleClose = () => {
    setLoading(false);
    onClose();
  };  

  async function handleSubmit() {
    setLoading(true);
    if (!capturedFile) return;
    await onSubmitPhoto(capturedFile);
    setLoading(false);
  }


  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title="Capturar Documento"
        showCancelButton={false}
        showConfirmButton={false}
        maxWidth="480px"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

          {/* CÂMERA */}
          {!preview && (
            <>
              <Webcam
                audio={false}
                ref={webcamRef}
                screenshotFormat="image/jpeg"
                screenshotQuality={1}
                forceScreenshotSourceSize={true}
                videoConstraints={videoConstraints}
                style={{ width: "100%", borderRadius: 12 }}
              />

              <button onClick={handleCapture} style={buttonStyle}>
                Tirar Foto
              </button>
            </>
          )}

          {/* PREVIEW DA FOTO */}
          {preview && (
            <div style={{ textAlign: "center" }}>
              <img
                src={preview}
                style={{ width: "100%", borderRadius: 12 }}
              />

              <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                <button
                  style={buttonStyle}
                  onClick={() => setPreview(null)}
                >
                  Tirar Outra Foto
                </button>

                {loading ? (
                  <button
                    style={{ ...buttonStyleSubmit, opacity: 0.6, cursor: "not-allowed" }}
                    disabled
                  >
                    Processando...
                  </button>
                ) : (
                  <button
                    style={buttonStyleSubmit}
                    onClick={handleSubmit}
                  >
                    Usar Esta Foto
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </Modal>

      <ManualReceiptModal
        isOpen={isManualModalOpen}
        onClose={() => setIsManualModalOpen(false)}
        data={missingFields}
        photoModalClose={onClose}
        onConfirm={(updated) => {
          setAdditionalInfo((prev) => ({
            ...prev,
            ...updated,
          }));
        }}
      />
    </>
  );
}

/** Converter Base64 → File (TSX Seguro) */
function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(",");
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : "";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}

const buttonStyle = {
  background: "#1f88e5",
  color: "white",
  padding: "10px 20px",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  width: "100%",
};

const buttonStyleSubmit = {
  ...buttonStyle,
  background: "green",
};
